import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from 'styles/app-styles'

export const Portfolio_s = styled.div`
  .p-paginator {
    bottom: 0px;
  }
`

export const PortfolioTable_s = styled(DataTable_s)`
  border-spacing: 15px;

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  // Hide filter input row
  .p-datatable-unfrozen-view thead.p-datatable-thead > tr:last-child {
    display: none;
  }

  .systemImmutable-row {
    background: ${Colors.athensGrey} !important;
  }
  .system-row .system-disabled {
    background: ${Colors.athensGrey};
  }

  .area-measure-input {
    width: 185px;
  }

  td.portfolio-name > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const AssetSelectionTable_s = styled(DataTable_s)`
  border-spacing: 15px;
  margin-top: -5px;

  .p-paginator {
    bottom: 0px;
  }

  .p-datatable-frozen-view .p-datatable-scrollable-header-table {
    position: fixed;
    z-index: 90;
    thead tr:last-child {
      div.p-dropdown { background: ${Colors.white}; }
      th:first-child {
        div.p-dropdown {
          left: 32px;
          width: 100px;
        }
        div.p-checkbox-box {
          border: 1px solid ${Colors.white};
          left: 6px;
          position: absolute;
          top: 40px;
        }
      }
    }
  }

  .p-datatable-scrollable-body-table {
    margin-top: 35px;
  }

  table.p-datatable-scrollable-header-table, table.p-datatable-scrollable-body-table {
    width: auto;
  }

  div.p-datatable-scrollable-view.p-datatable-frozen-view thead.p-datatable-thead tr:last-child {
    height: 41px;
  }

  thead.p-datatable-thead th.p-filter-column div.p-checkbox-box {
    background: ${Colors.white};
  }

  .p-selection-column {
    .p-checkbox {
      padding-left: 5px;
    }
    span.p-column-title {
      padding-left: 31px;
    }
  }

  th.p-filter-column > input, th.p-filter-column > div.p-dropdown {
    margin-bottom: 0;
    width: calc(100% - 8px);
  }

  thead > tr {
    th.p-filter-column:first-child {
      max-width: 45px;
    }
  }

  table.p-datatable-scrollable-body-table {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  }

  .p-datatable-thead > tr {
    height: 30px;
  }

  td.asset-name > span {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  // The following styles are to make sure the dropdowns filters on the unfrozen side of the table can overlay the table body //
  // Override from table styles
  .p-datatable-frozen-view .p-datatable-scrollable-header {
    position: unset !important;
    z-index: unset !important;
  }
  .p-datatable-scrollable-view.p-datatable-unfrozen-view {
    thead.p-datatable-thead {
      background: ${Colors.white};
      position: fixed;
      z-index: 1;
      th.p-editable-column:nth-child(2), th.p-editable-column:nth-child(4){
        position: fixed;
      }
    }
    .p-datatable-scrollable-body {
      margin-top: 5px;
    }
  }
  //////////////////////////////////////////////////////////////////////////

  .property-type-column svg {
    width: 16px;
    margin-left: 5px;
    vertical-align: middle;
    &.mf-icon {
      margin-left: 6px;
      width: 14px;
    }
    .r-svg {
      fill: ${Colors.blackPearl};
    }
  }
`
